import Adobe from "../providers/adobeReactivo";
import Facebook from "../providers/providersReactivo/facebook";
import Google from "../providers/providersReactivo/google";
import * as MUTATIONS from "../../config/constants/mutation-types";

const pixelDb = {
  triggers: {
    [MUTATIONS.ON_ROUTE]: {
      landing: ["Adobe.landing", "Facebook.landing", "Google.landing"],
      paso1: ["Adobe.paso1", "Facebook.paso1", "Google.paso1"],
      oferta: ["Adobe.oferta", "Facebook.oferta", "Google.oferta"],
      gracias: ["Adobe.gracias", "Facebook.gracias", "Google.gracias"],
      errorOferta: [
        "Adobe.errorOferta",
        "Facebook.errorOferta",
        "Google.errorOferta"
      ],
      mensaje: ["Adobe.mensaje", "Facebook.mensaje", "Google.mensaje"]
    },
    [MUTATIONS.ADOBE_APP_STARTED]: ["Adobe.appStartedClick"],
    [MUTATIONS.ADOBE_APP_ON_CLICK_START]: ["Adobe.appOnClickStart"],
    [MUTATIONS.ADOBE_ABRIR_CUENTA]: ["Adobe.abrirCuenta"],
    [MUTATIONS.ADOBE_INTERNAL_LINK]: ["Adobe.internalLink"],
    [MUTATIONS.ADOBE_PAGEVIEW]: ["Adobe.pageView"]
  },
  providers: {
    Adobe,
    Facebook,
    Google
  }
};

export default pixelDb;
